import React from 'react'
import { Number } from 'components'
import { config } from 'cmw-goaltools'
const { adjustDefaults } = config

export default function Profile(props) {
  return [
    <Number
      label="I am"
      message="years old"
      value={props.profile.age}
      min={18}
      max={70}
      handleUpdate={value => {
        props.goals.forEach(goal => {
          const {
            investStartAge,
            investStopAge,
            spendStartAge,
            spendStopAge,
          } = adjustDefaults(value, goal.category)
          props.setGoalProp(goal.id, 'investStartAge', investStartAge)
          props.setGoalProp(goal.id, 'investStopAge', investStopAge)
          props.setGoalProp(goal.id, 'spendStartAge', spendStartAge)
          props.setGoalProp(goal.id, 'spendStopAge', spendStopAge)
        })
        props.setPlanProp('age', value)
      }}
    />,
    <Number
      currency
      label="I have saved"
      message="in liquid assets"
      value={props.profile.savings}
      min={0}
      max={1000000000}
      handleUpdate={value => props.setPlanProp('savings', value)}
    />,
    <Number
      label="Average Equity Returns Assumption"
      message="percent"
      value={props.assetClassReturns.equity}
      min={0}
      max={50}
      handleUpdate={value =>
        props.setGlobalSetting('assetClassReturns', 'equity', value)
      }
    />,
    <Number
      label="Average Debt Returns Assumption"
      message="percent"
      value={props.assetClassReturns.debt}
      min={0}
      max={20}
      handleUpdate={value =>
        props.setGlobalSetting('assetClassReturns', 'debt', value)
      }
    />,
  ].map((input, idx) => <li key={idx}>{input}</li>)
}



// WEBPACK FOOTER //
// ./src/components/forms/Profile.js